import De from '@components/shared/Internationalization/icons/De';
import En from '@components/shared/Internationalization/icons/En';
import Es from '@components/shared/Internationalization/icons/Es';
import Nl from '@components/shared/Internationalization/icons/Nl';

export type LanguageType = {
  id: string;
  icon: React.FC;
  title: string;
  // Open Graph locale as language_TERRITORY. Meta's crawler rejects a bare
  // language code in og:locale (Graph API error 1611016), which made it
  // refuse the privacy policy URL configured on our Meta apps.
  ogLocale: `${string}_${string}`;
};

export const LANGUAGES: LanguageType[] = [
  { id: 'en', icon: En, title: 'English', ogLocale: 'en_US' },
  { id: 'de', icon: De, title: 'Deutsch', ogLocale: 'de_DE' },
  { id: 'es', icon: Es, title: 'Español', ogLocale: 'es_ES' },
  { id: 'nl', icon: Nl, title: 'Nederlands', ogLocale: 'nl_NL' },
];

// These languages were supported by the old website but are not supported by the new one
export const UNSUPPORTED_LANGS = ['fr', 'ru', 'sv'];
export const DEFAULT_LANG = 'en';
